import 'slick-carousel';

export default {
  init() {
    $('.htheme-posts_grid').each((i,grid) => {
      var $grid = $(grid);
      console.log($grid);
      var prev = $grid.find('.wmtm-prev')[0];
      var next = $grid.find('.wmtm-next')[0];
      $grid.find('.htheme-grid__slides').slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        slides: '.htheme-grid__slide',
        prevArrow: $(prev),
        nextArrow: $(next),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      })
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/htheme/pagebuilder/components/grid.js